import React from 'react';
import { Button } from './Button';
import { Trash2 } from 'lucide-react';

interface HuntDeletedModalProps {
  huntName: string;
  message: string;
  onDismiss: () => void;
}

/**
 * Modal shown when a hunt is deleted while user is participating
 */
export const HuntDeletedModal: React.FC<HuntDeletedModalProps> = ({
  huntName,
  message,
  onDismiss,
}) => {
  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
      <div className="bg-surface rounded-xl w-full max-w-md p-6 animate-slide-up">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center mb-4">
            <Trash2 className="w-8 h-8 text-red-500" />
          </div>
          
          <h2 className="text-xl font-semibold text-text-primary mb-2">
            Hunt Deleted
          </h2>
          
          <div className="text-lg text-primary font-medium mb-2">
            {huntName}
          </div>
          
          <p className="text-text-secondary mb-6">
            {message}
          </p>
          
          <Button
            variant="primary"
            onClick={onDismiss}
            className="w-full"
          >
            OK
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HuntDeletedModal;
